export enum FREQUENCY_TYPES {
  WEEK = 'week',
  MONTH = 'month',
  ONE_TIME = 'one-time',
}
